import React from 'react'

import {Cell} from 'fixed-data-table'

const DefaultCell = ({field, value, item, row, defaultValue, children, ...rest}) => {
   return <Cell {...rest}>{children || value || defaultValue}</Cell>
}

DefaultCell.propTypes = {
   children:     React.PropTypes.element,
   field:        React.PropTypes.string.isRequired,
   row:          React.PropTypes.object.isRequired,
   rowIndex:     React.PropTypes.number.isRequired,
   value:        React.PropTypes.string,
   defaultValue: React.PropTypes.string,
   link:         React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.string]),
   item:         React.PropTypes.any
}

export default DefaultCell



// WEBPACK FOOTER //
// lib/ui/table/DefaultCell.jsx